import { useMemo } from 'react';
import { AiOutlineQuestionCircle, AiOutlineCheck } from 'react-icons/ai'
import ReferenceImage from "../../components/reference-image";
import CustomInput from '../../components/custom-input'


const SingleProduct = ({ product, dispatch, onChange, selectedRepairs, openSidebar }) => {
    const categoryAlreadyExist = useMemo(() => {
        return !!selectedRepairs.filter(rep => rep.categoryId === product.categoryId).length
    }, [selectedRepairs, product])

    const checked = useMemo(() => {
        return selectedRepairs.findIndex(x => x.id === product.id) > -1
    }, [selectedRepairs, product.id])


    //updates comment field on repair.
    const updateComment = (text) => {
        const selectedRepairsCopy = [...selectedRepairs];
        const index = selectedRepairsCopy.findIndex(item => item.id === product.id);
        selectedRepairsCopy[index].commentField = text;
        dispatch({
            key: "selectedRepairs",
            value: selectedRepairsCopy
        })
    }

    //checks if category has in currently selected repairs. Used to determine if they can multiselect.
    const repairInSelected = useMemo(() => {
        const id = selectedRepairs.findIndex(i => i.id === product.id);
        if (id < 0) return undefined;
        return selectedRepairs[id];
    }, [selectedRepairs, product.id])

    //MIGHT HAVE TO BE REMOVED - HARDCODED UPSALE PRODUCT - Ignores products only made for upsale
    if (product.upsaleOnly) return null;

    return (
        <div className={`basis-full flex flex-row flex-wrap py-5 ${!product.categoryMultipleSelect && categoryAlreadyExist && !checked ? "text-gray-200" : "text-skgBlue"}`}>
            <div
                className={`flex ${product.warning ? "items-start" : "items-center"} flex-1`}
            >
                <input
                    type="checkbox"
                    id={`product_${product.id}`}
                    onChange={e => onChange(e, product)}
                    checked={checked}
                    className={`accent-skgBlue mr-4 ${product.warning ? "mt-0" : "-mt-1"}`}
                    disabled={!product.categoryMultipleSelect && categoryAlreadyExist && !checked}
                />
                <label
                    htmlFor={`product_${product.id}`}
                    className="-mt-1 flex-1 cursor-pointer"
                >
                    <div
                        className="flex flex-col-reverse md:flex-row"
                    >
                        {product.name}
                        {
                            product.campaign
                                ? (
                                    <span
                                        className='ml-1 text-xs bg-skgRed py-1 px-2 rounded-md text-white italic max-h-6 max-w-[80px]'
                                    >
                                        Kampagne
                                    </span>
                                )
                                : null
                        }
                        {
                            product.description
                                ? (
                                    <div
                                        className="flex items-center space-x-3 justify-end cursor-pointer hover:text-skgRed px-3"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            openSidebar(
                                                <div
                                                    className="text-white px-7 space-y-5"
                                                >
                                                    <p
                                                        className="text-2xl"
                                                    >
                                                        {product.name}
                                                    </p>
                                                    <div
                                                        style={{
                                                            lineHeight: "27px",
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: product.description }}
                                                    />
                                                    {
                                                        product.full_url && (
                                                            <ReferenceImage
                                                                src={product.full_url}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            )
                                        }}
                                    >
                                        <AiOutlineQuestionCircle
                                            size={20}
                                        />
                                    </div>
                                )
                                : null
                        }
                    </div>
                    {
                        product.warning && (
                            <div
                                className="text-xs mt-1 font-light"
                            >
                                {
                                    product.warning.split(',').length > 1
                                        ? (
                                            <div className="flex md:space-x-3 flex-wrap md:flex-nowrap">
                                                {
                                                    product.warning.split(',').map((item, i) => {
                                                        return (
                                                            <div
                                                                key={i}
                                                                className="flex items-center mr-2"
                                                            >
                                                                <AiOutlineCheck
                                                                    className="mr-1"
                                                                />
                                                                {item}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                        : (
                                            product.warning
                                        )
                                }
                            </div>
                        )
                    }
                </label>
            </div>
            <div
                className="flex items-center w-full md:w-1/3 justify-center md:justify-start mt-3 md:mt-0"
            >
                <div
                    className="justify-end items-end md:basis-2/4"
                >
                    {
                        !!+product.discount_pct
                            ? (
                                <div
                                    className="flex items-center space-x-3 justify-end cursor-pointer hover:text-skgRed"
                                >
                                    <div
                                        className='flex items-center space-x-2 flex-col'
                                    >
                                        <p
                                            className='text-xs'
                                        >
                                            {(product.discount_pct | 0) + "%"}
                                        </p>
                                        <p
                                            className='text-skgRed'
                                        >
                                            {
                                                (product.price - (product.price / 100 * product.discount_pct) | 0) + ",-"
                                            }
                                        </p>
                                    </div>
                                </div>
                            )
                            : null
                    }
                </div>
                <div
                    className="basis-1/4 flex justify-center"
                >
                    {
                        !!+product.price
                            ? (
                                <div
                                    className="bg-skgGray h-6"
                                    style={{
                                        width: "0.5px"
                                    }}
                                />
                            )
                            : null
                    }
                </div>
                {
                    !!+product.price && (
                        <div
                            className={`flex justify-end basis-1/4 flex-wrap flex-col`}
                        >
                            <p class="text-xs">
                                {
                                    !!product.price_from ? "Fra" : "Til"
                                }
                            </p>
                            <p class={`${product.discount_pct && product.discount_pct > 0 ? "line-through" : ""}`}>
                                {(product.price | 0) + ",-"}
                            </p>
                        </div>
                    )
                }

            </div>
            {
                !!product.comment && checked && (
                    <>
                        <hr
                            className="border-skgGray basis-full my-5"
                        />
                        <div
                            className='basis-full space-y-3 max-w-md ml-8'
                        >
                            <p
                                className="text-sm"
                            >
                                {product.comment_header}
                            </p>
                            <CustomInput
                                as={<textarea />}
                                labelText={`Kommentar`}
                                rows={4}
                                defaultValue={repairInSelected.commentField}
                                onBlur={(e) => {
                                    updateComment(e.target.value)
                                }}
                            />
                        </div>
                    </>

                )
            }
        </div>
    )
}

export default SingleProduct;